var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_7831",
    "data-name": "Group 7831",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.713,
    height: 30.712,
    viewBox: "0 0 30.713 30.712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7630",
    "data-name": "Path 7630",
    d: "M97.109,126.242a15.356,15.356,0,1,0-17.755,15.169V130.681h-3.9v-4.439h3.9v-3.383c0-3.849,2.293-5.974,5.8-5.974a23.623,23.623,0,0,1,3.437.3v3.779H86.655a2.219,2.219,0,0,0-2.5,2.4v2.881h4.259l-.681,4.439H84.152v10.731A15.359,15.359,0,0,0,97.109,126.242Z",
    transform: "translate(-66.397 -110.886)",
    fill: "#4676ed"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7631",
    "data-name": "Path 7631",
    d: "M118.488,151.05l.681-4.439H114.91v-2.881a2.219,2.219,0,0,1,2.5-2.4h1.936v-3.779a23.623,23.623,0,0,0-3.437-.3c-3.508,0-5.8,2.126-5.8,5.974v3.383h-3.9v4.439h3.9v10.731a15.526,15.526,0,0,0,4.8,0V151.05Z",
    transform: "translate(-97.154 -131.255)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.24df4b3c5cbb064674466e84002d64f6.svg";
export { ForwardRef as ReactComponent };